var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowTopRight = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M8.321 7.757c0-.47.38-.85.85-.85h7.071a.85.85 0 0 1 .85.85v7.071a.85.85 0 1 1-1.7 0V9.81l-7.034 7.035a.85.85 0 1 1-1.202-1.203l7.034-7.034H9.171a.85.85 0 0 1-.85-.85",
  clipRule: "evenodd"
})));
export default SvgArrowTopRight;